import React from 'react';
interface IngredientSectionProps {
  number: string;
  title: string;
  subtitle: string;
  description: string;
  imageUrl?: string;
  studyUrl?: string;
}
export const IngredientSection: React.FC<IngredientSectionProps> = ({
  number,
  title,
  subtitle,
  description,
  imageUrl,
  studyUrl
}) => {
  // Process description to handle bullet points and line breaks properly
  const formattedDescription = description.split('\n\n').map((paragraph, index) => {
    // Check if paragraph is a bullet point list
    if (paragraph.includes('\n') && paragraph.split('\n').some(line => line.trim().startsWith('•'))) {
      const lines = paragraph.split('\n');
      return <div key={index} className="mb-6" data-id="element-105">
            {lines.map((line, lineIndex) => {
          if (line.trim().startsWith('•')) {
            return <div key={lineIndex} className="flex items-start mb-3" data-id="element-106">
                    <span className="mr-3 text-lg" data-id="element-107">•</span>
                    <span data-id="element-108">{line.trim().substring(1).trim()}</span>
                  </div>;
          } else {
            return <p key={lineIndex} className="mb-3 leading-relaxed" data-id="element-109">
                    {line}
                  </p>;
          }
        })}
          </div>;
    } else {
      return <p key={index} className="mb-6 leading-relaxed" data-id="element-110">
            {paragraph}
          </p>;
    }
  });
  return <div className="my-12 md:my-16 py-6" data-id="element-111">
      <div className="flex flex-col md:flex-row gap-8" data-id="element-112">
        <div className="w-full md:w-1/3 flex-shrink-0 px-4 md:px-0" data-id="element-113">
          {imageUrl ? <div className="rounded-lg overflow-hidden mx-auto max-w-[80%] md:max-w-full" data-id="element-114">
              {studyUrl ? <a href={studyUrl} target="_blank" rel="noopener noreferrer" title="View clinical study" data-id="element-115">
                  <img src={imageUrl} alt={title} className="w-full h-auto object-cover aspect-square transition-opacity hover:opacity-90" data-id="element-116" />
                  <div className="text-center text-sm text-blue-600 mt-3" data-id="element-117">
                    Click image to view clinical study
                  </div>
                </a> : <img src={imageUrl} alt={title} className="w-full h-auto object-cover aspect-square" data-id="element-118" />}
            </div> : <div className="bg-gray-100 rounded-lg aspect-square flex items-center justify-center max-w-[80%] mx-auto md:max-w-full" data-id="element-119">
              <div className="text-center text-gray-400" data-id="element-120">
                <div className="text-lg" data-id="element-121">Image of compound</div>
              </div>
            </div>}
        </div>
        <div className="w-full md:w-2/3 px-4 md:px-0 mt-4 md:mt-0" data-id="element-122">
          <h3 className="text-2xl font-bold mb-3 text-center md:text-left" data-id="element-123">
            #{number}: {title}
          </h3>
          <h4 className="text-xl font-semibold mb-4 text-gray-700 text-center md:text-left" data-id="element-124">
            {subtitle}
          </h4>
          <div className="text-lg text-left md:text-left leading-relaxed" data-id="element-125">
            {formattedDescription}
          </div>
        </div>
      </div>
    </div>;
};